var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9941 2.65991H5.00586C3.34901 2.65991 2.00586 4.00306 2.00586 5.65991V18.3401C2.00586 19.9969 3.34901 21.3401 5.00586 21.3401H18.9941C20.651 21.3401 21.9941 19.9969 21.9941 18.3401V5.65991C21.9941 4.00306 20.651 2.65991 18.9941 2.65991Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26758 15.6017V8.49296C8.26758 8.1125 8.67562 7.87144 9.00885 8.05503L15.3093 11.5261C15.6504 11.714 15.6553 12.2024 15.3181 12.3971L9.01758 16.0347C8.68424 16.2271 8.26758 15.9866 8.26758 15.6017Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLine);
export default __webpack_public_path__ + "static/media/youtube_line.9b7ef3d36d65b5298eaef47b7c3e8558.svg";
export { ForwardRef as ReactComponent };